export const APP_ROUTES = {
    // Authentication
    LOGIN: "/login",
    LOGOUT: "/logout",
    FORGET_PASSWORD: "/forgot-password",
    FORGET_VERIFY_CODE: "/forget-verify-code/:tokenId",
    RESET_PASSWORD: "/reset-password/:tokenUUId",
    REGISTER: "/register",

    // Dashboard
    DASHBOARD: "/dashboard",

    // User Management
    USER_MANAGEMENT: "/users",
    USER_MANAGEMENT_DETAILS: "/users/:userId",

    // Singles
    AUDIO_CONTENT_MANAGEMENT: "/audio-management",
    AUDIO_CONTENT_MANAGEMENT_SINGLES: "/audio-management/singles",
    AUDIO_CONTENT_MANAGEMENT_SINGLES_ADD: "/audio-management/singles/create",
    AUDIO_CONTENT_MANAGEMENT_SINGLES_DETAILS: "/audio-management/singles/details/:singlesID",
    AUDIO_CONTENT_MANAGEMENT_SINGLES_UPDATE: "/audio-management/singles/edit/:singlesID",

    // Series
    AUDIO_CONTENT_MANAGEMENT_SERIES: "/audio-management/series",
    AUDIO_CONTENT_MANAGEMENT_SERIES_ADD: "/audio-management/series/create",
    AUDIO_CONTENT_MANAGEMENT_SERIES_DETAILS: "/audio-management/series/details/:seriesID",
    AUDIO_CONTENT_MANAGEMENT_SERIES_UPDATE: "/audio-management/series/edit/:seriesID",

    // Soundscapes
    AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES: "/audio-management/soundscapes",
    AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES_ADD: "/audio-management/soundscapes/create",
    AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES_DETAILS:
        "/audio-management/soundscapes/details/:soundscapesID",
    AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES_UPDATE:
        "/audio-management/soundscapes/edit/:soundscapesID",

    // Shares
    AUDIO_CONTENT_MANAGEMENT_SHARES: "/audio-management/stories",
    AUDIO_CONTENT_MANAGEMENT_SHARES_ADD: "/audio-management/stories/create",
    AUDIO_CONTENT_MANAGEMENT_SHARES_DETAILS: "/audio-management/stories/details/:sharesID",
    AUDIO_CONTENT_MANAGEMENT_SHARES_UPDATE: "/audio-management/stories/edit/:sharesID",

    // Series
    AUDIO_CONTENT_MANAGEMENT_ONBOARDING: "/audio-management/onboarding",
    AUDIO_CONTENT_MANAGEMENT_ONBOARDING_ADD: "/audio-management/onboarding/create",
    AUDIO_CONTENT_MANAGEMENT_ONBOARDING_DETAILS:
        "/audio-management/onboarding/details/:onboardingID",
    AUDIO_CONTENT_MANAGEMENT_ONBOARDING_UPDATE: "/audio-management/onboarding/edit/:onboardingID",

    // Goal Management
    GOAL_MANAGEMENT: "/goal-management",
    GOAL_MANAGEMENT_ADD: "/goal-management/create",
    GOAL_MANAGEMENT_PRIMARY: "/goal-management/primary",
    GOAL_MANAGEMENT_SECONDARY: "/goal-management/secondary",
    GOAL_PRIMARY_DETAIL: "/goal-management/primary/detail/:id",
    GOAL_SECONDARY_DETAIL: "/goal-management/secondary/:id",

    // GOAL_MANAGEMENT_SECONDARY_ADD: "/goal-management/secondary/add",
    GOAL_MANAGEMENT_EDIT: "/goal-management/edit/:id",
    GOAL_MANAGEMENT_PRIMARY_EDIT: "/goal-management/primary/edit/:id",
    GOAL_MANAGEMENT_SECONDARY_EDIT: "/goal-management/secondary/edit/:id",
    // GOAL_MANAGEMENT_SECONDARY_EDIT: "/goal-management/secondary/edit/:id",

    // Narrator Management
    AUTHOR_AND_NARRATOR_MANAGEMENT: "/author-&-narrator",
    AUTHOR_MANAGEMENT: "/author-&-narrator/authors",
    AUTHOR_DETAILS: "/author-&-narrator/authors/details/:id",
    NARRATOR_MANAGEMENT: "/author-&-narrator/narrators",
    NARRATOR_DETAILS: "/author-&-narrator/narrators/details/:id",
    NARRATOR_ADD: "/author-&-narrator/narrators/create",
    NARRATOR_EDIT: "/author-&-narrator/narrators/edit/:id",
    AUTHOR_ADD: "/author-&-narrator/authors/create",
    AUTHOR_EDIT: "/author-&-narrator/authors/edit/:id",

    // Notification Management
    NOTIFICATION_MANAGEMENT: "/notification",
    NOTIFICATION_MANAGEMENT_ADD: "/notification/create",
    NOTIFICATION_MANAGEMENT_DETAILS: "/notification/detail/:notificationID",
    NOTIFICATION_MANAGEMENT_UPDATE: "/notification/update:notificationID",

    // Account
    ACCOUNT: "/account",
    ACCOUNT_PROFILE: "/account/profile",
    UPDATE_ACCOUNT_PROFILE: "/account/profile/update",
    ACCOUNT_CHANGE_PASSWORD: "/account/change-password",

    // Provider Management
    PROVIDER_MANAGEMENT: "/provider-management",
    PROVIDER_MANAGEMENT_DETAILS: "/provider-management/:providerId",
    PROVIDER_DETAILS: "/provider-management/:providerId/details",
    PROVIDER_DETAILS_CATANDAVAIL: "/provider-management/:providerId/categories-and-availibility",
    PROVIDER_DETAILS_JOBS: "/provider-management/:providerId/jobs",
    PROVIDER_DETAILS_PROMOTIONS: "/provider-management/:providerId/promotions",
    PROVIDER_DETAILS_RATANDREVIEWS: "/provider-management/:providerId/rating-and-reviews",
    PROVIDER_MANAGEMENT_UPDATE: "/provider-management/update/:providerId",

    // Seeker Management
    SEEKER_MANAGEMENT: "/seeker-management",
    SEEKER_MANAGEMENT_DETAILS: "/seeker-management/:seekerId",
    SEEKER_PROFILE_DETAILS: "/seeker-management/:seekerId/details",
    SEEKER_DETAILS_CARE_PROFILE: "/seeker-management/:seekerId/care-profile",
    SEEKER_DETAILS_JOBS: "/seeker-management/:seekerId/jobs",
    SEEKER_DETAILS_RATANDREVIEWS: "/seeker-management/:seekerId/rating-and-reviews",
    SEEKER_MANAGEMENT_UPDATE: "/seeker-management/update/:seekerId",

    //Category Management
    CATEGORY_MANAGEMENT: "/category-management",
    CATEGORY_MANAGEMENT_DETAILS: "/category-management/:categoryId",

    //Job Listing
    JOB_LISTING: "/jobs",
    JOB_LISTING_DETAIL: "/jobs/:jobId"

    // Account
    // ACCOUNT_PROFILE: "/account/profile",
    // UPDATE_ACCOUNT_PROFILE: "/account/profile/update",
    // ACCOUNT_CHANGE_PASSWORD: "/account/update"
};

// export const getParamsAttachedRoute = (route, obj = {}) => {
//     let keys = Object.keys(obj);
//     console.log("keys", keys, obj);
//     if (keys?.length) {
//         let objectKeys = keys;

//         objectKeys.forEach(() => {
//             route = route.replace(new RegExp(/:([\d\w?])+/, "i"), (match) => {
//                 let formattedMatchedValue =
//                     match[match.length - 1] === "?"
//                         ? match.slice(1, match.length - 1)
//                         : match.slice(1);
//                 return obj[formattedMatchedValue];
//             });
//         });
//         console.log("111111111", route);
//         return route;
//     }
//     console.log("222222222", route);
//     return route;
// };

export const getParamsAttachedRoute = (route, obj = {}) => {
    const keys = Object.keys(obj);

    if (!keys.length) {
        console.warn(`No parameters provided for route: ${route}`);
        return route; // Return the original route if no params are provided
    }

    keys.forEach((key) => {
        const regex = new RegExp(`:${key}\\??`, "g"); // Match :key or :key?
        const value = obj[key];

        if (value !== undefined) {
            route = route.replace(regex, value);
        } else if (regex.test(route)) {
            // If parameter is optional (contains ?), remove it from the route
            route = route.replace(regex, "").replace(/\/{2,}/g, "/");
        } else {
            console.error(`Missing required parameter: ${key}`);
        }
    });

    return route;
};
